<template>
  <div
    style="width: 409px ; padding: 10px ; border: 1px solid lightgray ; border-radius: 10px ; float: left;align-content: center;justify-content: center;">
    <div class="iran-flag-place dark"><img src="../forms/iran-flag-dark.a2c7c8c.svg"
                                           alt="پرچم ایران" width="18px" style="font-size: 24px;direction: ltr;
font-weight: 650;
line-height: 24px;margin-top: 10px;
color: #222"></div>
    <v-text-field
      style="width: 75px ; float: left ; font-size: 24px"
      height="40px"
      v-model="p1"
      hide-details
      solo
      @keyup="p1f()"
      v-mask="'##'"
      placeholder="--"
      ref="p1"
      class="centered-input"
      @input="handleInput"
    />
    <v-text-field
      style="width: 60px ; float: left ; font-size: 24px ; margin-left: 5px ;font-weight: lighter;"
      class="centered-input"
      readonly
      height="40px"
      hide-details
      v-model="p2"
      @click="AlphabetsDialog=true"
      ref="p2"
      placeholder="-"
      solo
      @input="handleInput"
    />
    <v-text-field
      style="width: 100px ; float: left ; font-size: 24px ; margin-left: 5px"
      height="40px"
      v-model="p3"
      @keyup="p3f()"
      hide-details
      solo
      ref="p3"
      v-mask="'###'"
      placeholder="---"
      class="centered-input"
      @input="handleInput"
    />
    <div
      style="width: 1px ; height: 35px ; background: lightgray ;  ; float: left ; margin-top: 5px ; margin-left: 10px"></div>
    <v-text-field
      style="width: 75px ; float: left ; font-size: 24px ; margin-left: 10px"
      height="40px"
      hide-details
      solo
      v-mask="'##'"
      v-model="p4"
      @keyup="p4f()"
      ref="p4"
      placeholder="--"
      class="centered-input"
      @input="handleInput"
    />
    <v-dialog
      v-model="AlphabetsDialog"
      width="500px"
    >
      <v-card>
        <v-card-text style="width: 100% ; text-align: center">
          <v-btn v-for="alphabet in alphabets" rounded outlined style="margin: 10px"
                 @click="setAlpha(alphabet)" :key="alphabet+'alpha'">
            <template v-if="alphabet!=='M'">
              {{ alphabet }}
            </template>
            <template v-else>
              <v-icon>{{ mdiWheelchairAccessibility }}</v-icon>
            </template>
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" block @click="AlphabetsDialog = false">خروج</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mask} from 'vue-the-mask'
import {mdiWheelchairAccessibility} from "@mdi/js"

export default {
  name: "iran-car-plaque",
  prop: ['value'],
  data() {
    return {
      content: this.value,
      mdiWheelchairAccessibility: mdiWheelchairAccessibility,
      p1: "",
      p2: "",
      p3: "",
      p4: "",
      AlphabetsDialog: false,
      alphabets: [
        "الف",
        "ب",
        "پ",
        "ت",
        "ث",
        "ج",
        "چ",
        "ح",
        "خ",
        "د",
        "ذ",
        "ر",
        "ز",
        "ش",
        "س",
        "ط",
        "ظ",
        "ک",
        "گ",
        "ل",
        "م",
        "ن",
        "و",
        "ه",
        "ی",
        "S",
        "D",
        "M",
      ]
    }
  },
  directives: {mask},
  methods: {
    handleInput(e) {
      this.content = this.p1.toString() + this.p2.toString() + this.p3.toString() + this.p4.toString()
      this.$emit('input', this.content)
    },
    p1f() {
      if (this.p1.length === 2) {
        this.AlphabetsDialog = true
        this.$refs.p3.focus()
      }
    },
    setAlpha(value) {
      this.p2 = value
      this.handleInput()
      this.AlphabetsDialog = false
      this.$refs.p3.focus()
    },
    p3f() {
      if (this.p3.length === 3) {
        this.$refs.p4.focus()
      }
      if (this.p3.length === 0) {
        this.AlphabetsDialog = true
      }
    },
    p4f() {
      if (this.p4.length === 0) {
        this.$refs.p3.focus()
      }
    },
    update(value){
      console.log(value)
    }
  }
}
</script>

<style scoped>
.iran-flag-place {
  background-color: #01286d;
  width: 36px;
  height: 50px;
  border-radius: 8px 4px 4px 8px;
  margin-right: 8px;
  float: left;
  text-align: center;
}

.centered-input >>> input {
  text-align: center;
  max-height: 40px;
}

.left-input >>> input {
  text-align: left;
  max-height: 40px;
}

input {
  max-height: 40px;
}

</style>
